import { motion } from 'framer-motion';

interface ProgressBarProps {
  progress: number;
  currentIndex: number;
  total: number;
}

export function ProgressBar({ progress, currentIndex, total }: ProgressBarProps) {
  return (
    <div className="mt-auto flex justify-center items-center space-x-4">
      <div className="h-2 w-48 bg-gray-200 rounded-full overflow-hidden">
        <motion.div
          className="h-full bg-gradient-to-r from-[#ffce04] to-[#ff8a47]"
          initial={{ width: "0%" }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.3 }}
        />
      </div>
      <span className="text-base md:text-lg text-gray-500">
        {currentIndex + 1} de {total}
      </span>
    </div>
  );
}
